var Chaplin, Description, DescriptionPopupView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/description-popup');

View = require('views/base/view');

Chaplin = require('chaplin');

Description = require('models/description');

module.exports = DescriptionPopupView = (function(_super) {
  __extends(DescriptionPopupView, _super);

  function DescriptionPopupView() {
    _ref = DescriptionPopupView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  DescriptionPopupView.prototype.template = template;

  DescriptionPopupView.prototype.className = 'popup';

  DescriptionPopupView.prototype.tagName = 'div';

  DescriptionPopupView.prototype.id = 'description-popup';

  DescriptionPopupView.prototype.autoRender = false;

  DescriptionPopupView.prototype.container = 'body';

  DescriptionPopupView.prototype.listen = {
    'catalogue:hideDescription mediator': 'closePopup',
    'sync model': 'render'
  };

  DescriptionPopupView.prototype.events = {
    'click .btn-close': 'closeAllDescriptions',
    'click .btn-cart': 'showCartPopup'
  };

  DescriptionPopupView.prototype.closePopup = function() {
    this.dispose();
    return false;
  };

  DescriptionPopupView.prototype.closeAllDescriptions = function() {
    this.publishEvent('catalogue:hideAllDescriptions');
    return false;
  };

  DescriptionPopupView.prototype.initialize = function(options) {
    var catalogue, error, hotspot, product, _ref1;
    hotspot = options.hotspot;
    catalogue = Chaplin.mediator.catalogue;
    product = (_ref1 = catalogue.get('description')) != null ? _ref1.products[hotspot.title] : void 0;
    if (!(product != null ? product.desc : void 0)) {
      error = 'No description';
    }
    this.model = new Description({
      left: hotspot.left,
      top: hotspot.top,
      polygonHeight: hotspot.polygonHeight,
      polygonWidth: hotspot.polygonWidth,
      offsetPosition: hotspot.offsetPosition,
      page: hotspot.page,
      productURL: hotspot.url,
      title: hotspot.title,
      product: product,
      error: error
    });
    return this.render();
  };

  DescriptionPopupView.prototype.attach = function() {
    var pagePosition;
    DescriptionPopupView.__super__.attach.apply(this, arguments);
    pagePosition = $("#map-" + (this.model.get('page'))).offset();
    return this.moveToPosition(pagePosition.left + parseInt(this.model.get('left')), pagePosition.top + parseInt(this.model.get('top')));
  };

  DescriptionPopupView.prototype.moveToPosition = function(left, top) {
    if (this.model.get('offsetPosition').left > $('body').width() / 2) {
      this.$el.css({
        'left': left - this.$el.width() - 20
      });
      this.$el.addClass('right');
    } else {
      this.$el.css({
        'left': left + 20 + this.model.get('polygonWidth')
      });
      this.$el.addClass('left');
    }
    if (top < Chaplin.mediator.catalogue.get('image_sizes').normal.height / 2) {
      this.$el.css({
        'top': top
      });
      return this.$el.addClass('top');
    } else {
      this.$el.css({
        'top': top + this.model.get('polygonHeight') - this.$el.height()
      });
      return this.$el.addClass('bottom');
    }
  };

  DescriptionPopupView.prototype.showCartPopup = function() {
    return this.model.addToCart();
  };

  return DescriptionPopupView;

})(View);
